import { Box, Tooltip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const AvailabilitySlotValue = ({
  count,
  freeText,
  isWarning = false,
  dense = false,
  overrideBlocked = 0,
}) => {
  // Places blocked by a capacity override are not visible in the booking cards,
  // so the slot gets a marker explaining the reduced availability.
  const blocked = Number(overrideBlocked || 0);
  const hasOverride = Number.isFinite(blocked) && blocked > 0;

  const content = (
    <>
      <Box component='span'>{count}</Box>
      <Box component='span' sx={{ fontSize: dense ? '0.8em' : '0.85em', whiteSpace: 'nowrap' }}>
        ({freeText})
      </Box>
      {hasOverride && (
        <Box
          component='span'
          aria-label={`${blocked} zusätzlich blockierte Plätze durch Kapazitätsübersteuerung`}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '1px',
            fontSize: dense ? '0.8em' : '0.85em',
            fontWeight: 700,
            whiteSpace: 'nowrap',
          }}
        >
          <LockIcon sx={{ fontSize: '1em' }} />
          {blocked}
        </Box>
      )}
    </>
  );

  const wrapWithOverrideTooltip = node =>
    hasOverride ? (
      <Tooltip
        title={`Kapazitätsübersteuerung: ${blocked} zusätzliche Plätze blockiert (z. B. Gruppe spielt unter sich)`}
        arrow
      >
        {node}
      </Tooltip>
    ) : (
      node
    );

  if (!isWarning) {
    return wrapWithOverrideTooltip(
      <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
        {content}
      </Box>
    );
  }

  return wrapWithOverrideTooltip(
    <Box
      component='span'
      sx={theme => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: '3px',
        px: 0.5,
        py: '1px',
        borderRadius: 0.75,
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.error.contrastText,
        boxShadow: `0 0 0 1px ${theme.palette.error.contrastText}55`,
        whiteSpace: 'nowrap',
      })}
    >
      {content}
    </Box>
  );
};

export default AvailabilitySlotValue;
